var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-button',{class:[_vm.className, _vm.classObject],attrs:{"type":_vm.type,"form":_vm.form},on:{"click":_vm.handleClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }